import { maxAdultsForOrganization } from "@/helpers/maxAdultsForOrganization.ts";
import { useGetOrganization } from "@/helpers/useGetOrganization.tsx";

/**
 * Adult limit for the current organization, or undefined when there is none
 */
export const useMaxAdults = (): number | undefined => {
  const { organizationName } = useGetOrganization();

  return maxAdultsForOrganization(organizationName);
};
